import { apiClient } from '../http';

export const FAVORITE_RESOURCE_TYPES = [
    'dashboards',
    'folders',
    'investments',
    'lists',
    'lifecycles',
    'memos',
    'pipelines',
    'reports',
    'teams',
] as const;

export type FavoriteResourceType = (typeof FAVORITE_RESOURCE_TYPES)[number];

export interface FavoriteItem<TResource = unknown> {
    createdAt: string;
    id: string;
    resource: TResource;
    resourceId: string;
    resourceType: FavoriteResourceType;
    updatedAt: string;
}

export const favoriteService = {
    list: <TResource = unknown>(resourceType?: FavoriteResourceType) =>
        apiClient.get<FavoriteItem<TResource>[]>('/api/favorites', {
            params: resourceType ? { resourceType } : undefined,
        }),
    set: async <TResource = unknown>(resourceType: FavoriteResourceType, resourceId: string, favorited: boolean) => {
        if (favorited) {
            await apiClient.put<FavoriteItem<TResource>>(`/api/favorites/${resourceType}/${resourceId}`);

            return;
        }

        await apiClient.delete<void>(`/api/favorites/${resourceType}/${resourceId}`);
    },
};
